import {
  ModalBody,
  ModalContainer,
  ModalHeader,
  ModalRoot,
} from '@mentimeter/ragnar-ui/modal';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useTranslations } from 'next-intl';

export const AudienceLimitReachedModal = ({ open }: { open: boolean }) => {
  const translate = useTranslations('participating.audience_limit_modal');
  return (
    <ModalRoot open={open}>
      <ModalContainer dismissable={false}>
        <ModalHeader dismissable={false}>
          {translate('header_message')}
        </ModalHeader>
        <ModalBody>
          <Text color="textWeak">{translate('body_message')}</Text>
        </ModalBody>
      </ModalContainer>
    </ModalRoot>
  );
};
